
import {
  Vue,
  Component,
  Watch,
  Prop,
  Model,
  Emit,
} from 'vue-property-decorator';

@Component({})
export default class SelfPperatedField extends Vue {
  val: any = 0;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  form!: number;

  @Model('change')
  value!: any;

  @Watch('val')
  watchInternalVal(): void {
    this.updateVal();
  }

  @Watch('value')
  watchValue() {
    this.val = this.value;
  }

  @Emit('update')
  updateVal() {
    return this.val;
  }

  mounted() {
    this.watchValue();
  }

  onChange() {}
}
